import React from 'react'
import cn from 'classnames'

interface Props {
  modifyValue: (val: string) => void // Example: (e) => this.setState({ value: e.target.value })
  value: string | number // state variable updated by onChange function, key in options
  options: { key: string; value: string }[] // Dropdown values
  label?: string // Label above dropdown (optional)
  name?: string // Dropdown name (optional, but nice to have with label)
  className?: string // Specific styling options for dropdown
  open: Boolean
  handleOpen: () => void
}
const Select = ({
  modifyValue,
  value,
  label,
  name = 'select__name',
  options,
  className = '',
  open,
  handleOpen
}: Props) => {
  return (
    <div>
      {label && (
        <label htmlFor={name} className='select__label'>
          {label}
        </label>
      )}
      <div className={cn('select__container', className)} onClick={handleOpen}>
        <span className={cn('select__ghost', { 'select__ghost--open': open })}></span>
        <div className={cn('select', { open: open })}>
          <div className='select__trigger'>
            <span>{value}</span>
            <div className='select__arrow'></div>
          </div>
          <div className='select__options'>
            {options.map(o => (
              <span
                className={cn('select__option', { selected: o.key === value })}
                key={o.key}
                data-value={o.value}
                onClick={(e: React.MouseEvent) => {
                  modifyValue((e.currentTarget as any).getAttribute('data-value'))
                }}
              >
                {o.value}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Select
